import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { SharedFile } from '../types';

interface SharedFilesProps {
  files: SharedFile[];
  currentUserRole: 'teacher' | 'student';
  onUploadFile?: () => void;
  onDownloadFile: (fileId: string) => void;
}

const SharedFiles = ({
  files,
  currentUserRole,
  onUploadFile,
  onDownloadFile,
}: SharedFilesProps) => {
  const getFileIcon = (type: string) => {
    if (type.includes('pdf')) return 'FileText';
    if (type.includes('image')) return 'Image';
    if (type.includes('video')) return 'Video';
    if (type.includes('word') || type.includes('doc')) return 'FileText';
    if (type.includes('excel') || type.includes('sheet')) return 'Table';
    if (type.includes('powerpoint') || type.includes('presentation')) return 'Presentation';
    return 'File';
  };

  const formatDate = (date: Date) => {
    return date.toLocaleDateString('ro-RO', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Icon name="Paperclip" size={20} className="text-primary" />
          <h3 className="text-sm font-semibold text-foreground">
            Fișiere partajate ({files.length})
          </h3>
        </div>
        {currentUserRole === 'teacher' && (
          <Button
            variant="outline"
            size="sm"
            onClick={onUploadFile}
            iconName="Upload"
            iconSize={14}
          >
            Încarcă
          </Button>
        )}
      </div>

      {files.length === 0 ? (
        <div className="text-center py-6">
          <Icon name="FolderOpen" size={48} className="text-muted-foreground mx-auto mb-3" />
          <p className="text-sm text-muted-foreground">Nu există fișiere partajate încă</p>
        </div>
      ) : (
        <div className="space-y-2 max-h-64 overflow-y-auto">
          {files.map((file) => (
            <div
              key={file.id}
              className="flex items-center justify-between p-3 rounded-md border border-border hover:bg-muted transition-colors duration-150"
            >
              <div className="flex items-center gap-3 flex-1 min-w-0">
                <div className="w-10 h-10 rounded-md bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Icon
                    name={getFileIcon(file.type)}
                    size={20}
                    className="text-primary"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-foreground truncate">
                    {file.name}
                  </p>
                  <div className="flex items-center gap-2 text-xs text-muted-foreground mt-0.5">
                    <span>{file.size}</span>
                    <span>•</span>
                    <span>{file.uploadedBy}</span>
                    <span>•</span>
                    <span>{formatDate(file.uploadedAt)}</span>
                  </div>
                </div>
              </div>
              <button
                onClick={() => onDownloadFile(file.id)}
                className="p-2 rounded-md hover:bg-muted-foreground/10 transition-colors duration-150 flex-shrink-0"
                aria-label={`Descarcă ${file.name}`}
              >
                <Icon name="Download" size={16} className="text-muted-foreground" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SharedFiles;
